import { render, staticRenderFns } from "./audio-medium.vue?vue&type=template&id=992b181a&scoped=true&"
import script from "./audio-medium.vue?vue&type=script&lang=js&"
export * from "./audio-medium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992b181a",
  null
  
)

export default component.exports